import { PageHeader } from "@business-finland/wif-ui-lib/dist/PageHeader";
import dynamic from "next/dynamic";
import { useEffect, useRef } from "react";

import useEmployerSite from "../../../../contexts/EmployerSiteContext";
import { getCompanyFormId } from "../helpers";

const HtmlParser = dynamic(() => import("../../../../components/HtmlParser"));

export default function ThankYou({
  id,
  className,
  heading,
  leadText,
}: {
  id: string;
  className: string;
  heading: string;
  leadText: string;
}) {
  const { isEmployerSite } = useEmployerSite();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div key={id} id={id} className={className} ref={ref}>
      <PageHeader
        id={getCompanyFormId("header")}
        heading={heading}
        leadText={<HtmlParser html={leadText} />}
        backgroundColor={isEmployerSite ? "blue" : "lightBlue"}
      />
    </div>
  );
}
